<script lang="ts">
    import {Heading, Toggle} from "flowbite-svelte";
    import Avatar from "$lib/components/Avatar.svelte";
    import CopyToClipboard from "$lib/components/CopyToClipboard.svelte";
    import Steps from "$lib/components/Steps.svelte";
    import Tabs from "$lib/components/Tabs.svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import SearchFilter from "$lib/components/SearchFilter.svelte";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import Pagination from "$lib/components/Pagination.svelte";
    import {writable} from "svelte/store";
    import VerticalGridPreview from "$lib/partials/ui/VerticalGridPreview.svelte";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import FileDrop from "$lib/components/FileDrop.svelte";
    import ModalPreview from "$lib/partials/ui/ModalPreview.svelte";
    import CardLayout from "$items/CardLayout.svelte";
    import Ldw1 from "./layouts/Ldw1.svelte";

    const editMode = writable(false)

    const components = {
        layout: [
            {
                name: 'LDW1',
                component: Ldw1
            }
        ],
        display: [
            {
                name: '$store / Modal',
                component: ModalPreview,
                props: {
                    super_edit: editMode
                }
            },
            {
                name: 'lib/components/Avatar',
                component: Avatar,
                props: {
                    associate: {
                        firstName: 'John',
                        lastName: 'Doe'
                    }
                }
            }, {
                name: 'lib/components/CopyToClipboard',
                component: CopyToClipboard,
                props: {
                    textToCopy: 'test'
                }
            }, {
                name: 'lib/components/Steps',
                component: Steps,
                props: {
                    steps: [
                        {
                            label: 'Step 1',
                            route: '/ui'
                        },
                        {
                            label: 'Step 2',
                            route: '/ui'
                        }
                    ]
                }
            }, {
                name: 'lib/components/Tabs',
                component: Tabs,
                props: {
                    tabs: ['Tab 1', 'Tab 2'],
                    activeTab: 0
                }
            }
        ],
        content: [
            {
                name: 'lib/components/Pagination',
                component: Pagination,
                props: {
                    pagination: {
                        pages: 3,
                        page: 1
                    }
                }
            }, {
                name: 'lib/components/VerticalGrid',
                component: VerticalGridPreview,
                props: {},
            },{
                name: 'lib/components/SortableTable',
                component: SortableTable,
                props: {
                    data: [{name: 'test 1', id: 1}, {name: 'test 2', id: 2}],
                    header: [{label: 'Name', property: 'name', sortable: true}, {label: 'ID', property: 'id'}]
                }
            }, {
                name: 'items/CardLayout',
                component: CardLayout,
                props: {
                    title: 'Card / Box',
                    accordion: true
                }
            }
        ],
        input: [
            {
                name: 'lib/items/InfoBox',
                component: InfoBox,
                props: {
                    title: 'Label',
                    value: 'Value',
                    super_edit: editMode
                }
            },{
                name: 'lib/components/SearchFilter',
                component: SearchFilter,
                props: {
                    super_edit: editMode
                }
            },{
                name: 'lib/components/Typeahead',
                component: Typeahead,
                props: {
                    data: [{name: 'test 1'}, {name: 'test 2'}],
                }
            },{
                name: 'lib/components/FileDrop',
                component: FileDrop,
                props: {}
            }

        ],
    }

</script>
<div class="flex gap-3">
    <div class="px-5 mt-5">
        <Toggle bind:checked={$editMode} class="my-3">Editing</Toggle>
    </div>
    <div class="my-5 w-4/5 mx-auto">
        <Heading tag="h1" class="text-neutral-600">UI</Heading>
        <p>General: <a target="_blank" class="text-primary-700 hover:text-primary-600" href="https://flowbite-svelte.com/docs/components/accordion">Flowbite</a></p>
        {#each Object.entries(components) as [category,items]}
            <Heading tag="h2" class="text-neutral-600 mt-6">{category.toUpperCase()}</Heading>
            <div class="grid gap-3 my-3">
                {#each items as component}
                    <div class="border rounded border-neutral-100 shadow p-5 flex flex-col">
                        <p class="text-neutral-600"><a
                                target="_blank"
                                href="https://github.com/recrew/retech.rest/tree/master/apps/portal/src/{component.name}.svelte">{component.name}</a></p>
                        <div class="flex-1">
                            <svelte:component this={component.component} {...component.props} />

                        </div>


                    </div>

                {/each}
            </div>
        {/each}


    </div>
</div>

